'use client';

import { RefObject, useCallback, useRef, useState } from 'react';
import useEscapeKeydown from '@/hooks/useEsacapeKeydown';
import { IconBell } from '@/assets/icons/IconBell';
import { SnapshotAlertPopover } from './SnapshotAlertPopover';
import styles from './snapshotpopover.module.scss';

export function AnonymousAlertSnapshotIcon(): React.JSX.Element {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    useEscapeKeydown(handleClose);

    return (
        <div className={styles.snapshotTrigger}>
            <button
                ref={buttonRef}
                aria-expanded={open}
                aria-haspopup="dialog"
                aria-label="notifications"
                className={styles.snapshotIconButton}
                onClick={() => setOpen((previousOpen) => !previousOpen)}
                type="button"
            >
                <IconBell />
            </button>

            <SnapshotAlertPopover
                buttonRef={buttonRef as RefObject<HTMLButtonElement | null>}
                onClose={handleClose}
                open={open}
            />
        </div>
    );
}
